module.exports = __webpack_public_path__ + "static/media/0001.0125b19f.jpg";